import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';

import { RequestStatus } from '../../types';

import { Broadcast, BroadcastState } from './broadcastTypes';

const initialState: BroadcastState = {
  status: 'none'
};

const broadcastSlice = createSlice({
  name: 'broadcast',
  initialState,
  reducers: {
    fetchBroadcastsSuccess(state: Draft<BroadcastState>, action: PayloadAction<Broadcast | undefined>) {
      state.status = 'none';
      state.broadcast = action.payload;
    },
    setBroadcastFailure(state: Draft<BroadcastState>, action: PayloadAction<string | Error>) {
      const reason = typeof action.payload === 'string' ? action.payload : action.payload.message;

      state.status = 'error';
      state.reason = reason;
    },
    clearBroadcast(state) {
      state.status = 'none';
      state.broadcast = undefined;
    },
    setBroadcastStatus(state, action: PayloadAction<RequestStatus>) {
      state.status = action.payload;
    },
    stopBroadcast(state) {
      state.status = 'none';

      if (state.broadcast) {
        state.broadcast.isRunning = false;
        state.broadcast.timeLeft = '0h 0m';
      }
    }
  }
});

export const {
  fetchBroadcastsSuccess,
  setBroadcastFailure,
  clearBroadcast,
  setBroadcastStatus,
  stopBroadcast
} = broadcastSlice.actions;

export const broadcastReducer = broadcastSlice.reducer;
